import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { getUnionDueService } from "@WhiteCap/Services/UnionDueService";

export interface UnionDueModel extends BaseModel {
    showUnionDue: boolean;
    unionDueBalance: number;
    unionDueBalanceDisplay: string;
}

type HandlerType = ApiHandler<HasOnSuccess<UnionDueModel>, UnionDueModel>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getUnionDueService();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback];

const unionDueHandler = createHandlerChainRunner(chain, "UnionDueHandler");
export default unionDueHandler;
